import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, AfterViewChecked, ChangeDetectorRef} from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-dropdown-with-error',
  templateUrl: './dropdown-with-error.component.html',
  styleUrls: ['./dropdown-with-error.component.less']
})
export class DropdownWithErrorComponent implements OnInit, OnDestroy, AfterViewChecked {

  @Input() dropdownLabel: string;
  @Input() showAny: boolean;
  @Input() fieldName: string;
  @Input() colorStyle: string;
  @Input() sourceList: any[];
  @Input() disabled = false;
  @Input() showOneLine = false;
  _questionType: string;
  showError = false;
  @Input() eventValidate: Observable<number[]>;
  @Input() eventValidateSubscription: any;
  @Input() id: number;
  @Input() operator: string;

  @Output() userChoice: EventEmitter<string> = new EventEmitter<string>();

  dropdown: boolean;

  constructor(protected cdRef: ChangeDetectorRef) {}

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngOnInit() {
    this.dropdown = false;
    if (this.showAny === undefined) {
      this.showAny = true;
    }

    if (this.eventValidate) {
      this.eventValidateSubscription = this.eventValidate.subscribe((listId) => {
        if (listId.includes(this.id)) {
          this.showError = !this.dropdownLabel;
        } else {
          this.showError = false;
        }
      });
    }
  }

  onClickOutside(event: Object) {
    if (event && event['value'] === true) {
      this.dropdown = false;
    }
  }

  toggleDropdown() {
    if (!this.disabled) {
      this.dropdown = !this.dropdown;
    }
  }

  changeLabel(s) {
    if (s === 'Any') {
      this.dropdownLabel = s;
    } else {
      if (this.fieldName === undefined || this.fieldName === '') {
        this.dropdownLabel = s;
      } else {
        this.dropdownLabel = s[this.fieldName];
      }
    }
    this.userChoice.emit(s);
    this.showError = false;
  }

  setDefaultDropdownLabel(s: string) {
    this.dropdownLabel = s;
  }

  @Input()
  set questionType(value: string) {
    if ((value === 'MultipleChoice' || value === 'SingleChoice') && !this.operator) {
      this.changeLabel(this.sourceList[0]);
      this.dropdownLabel = this.sourceList[0];
    }
  }

  ngOnDestroy(): void {
    if (this.eventValidateSubscription) {
      this.eventValidateSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown-with-error/dropdown-with-error.component.ts